import { useMediaQuery } from 'usehooks-ts';

export const useIsMobile = (query?: string) => {
  const isMobile = useMediaQuery(query ?? '(max-width: 768px)');

  return isMobile;
};
